var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderPackingDetail',{attrs:{"label":"Pengeluaran Grup","pengemasan-path":"gudang.reimbursement-group.pengemasan","cancelable":false,"index-path":{ name: 'gudang.reimbursement-group.index' }}})
}
var staticRenderFns = []

export { render, staticRenderFns }